import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SpinnerService } from './spinner.service';
import firebase from 'firebase/compat/app';
import { ShoppingService } from './shopping.service';

@Injectable({
  providedIn: 'root',
})
export class CheckoutService {
  private url = environment.urlBackend;

  constructor(
    private http: HttpClient,
    private spinnerService: SpinnerService,
    public shopping: ShoppingService
  ) {}

  // The API answers 409 when the business cannot sell yet (no Mercado Pago or no commission rate)
  // or the drinks are not bought for an event in course. Returns the message to show, or null.
  public salesDisabledMessage(data: any, target: 'evento' | 'carta'): string | null {
    if (data?.code !== 409) return null;
    if (target === 'carta' && data.reason === 'event') return 'Esta carta no tiene un evento en curso.';
    return target === 'evento'
      ? 'La venta todavía no está habilitada para este evento.'
      : 'La venta todavía no está habilitada para esta carta.';
  }

  // The checkout refusals a buyer can act on keep their words; anything else gets one plain instruction.
  public checkoutErrorMessage(data: any, target: 'evento' | 'carta'): string {
    const disabled = this.salesDisabledMessage(data, target);
    if (disabled) return disabled;
    if (/^(Cantidades no válidas|No quedan)/.test(data?.message || '')) return data.message;
    return 'No pudimos iniciar el pago. Actualiza la página, revisa tu carrito y vuelve a intentarlo.';
  }

  public async checkoutBar(data: any) {
    const authToken = await firebase!.auth()!.currentUser!.getIdToken();

    const items: Array<any> = [];

    data.forEach((element: any) => {
      items.push({
        uid: element.uid,
        title: element.name,
        unit_price: Number(element.price),
        quantity: element.quantity,
      });
    });

    const uidMenu = await this.shopping.getTicketUidMenu();

    return this.http
      .post(
        this.url + 'checkout/bar',
        { items, idMenu: uidMenu, idEvent: this.shopping.getTicketUidEventMenu() },
        {
          headers: { Authorization: `Bearer ${authToken}` },
        }
      )
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error) => {
          return of(error.error);
        })
      );
  }

  public async checkoutAccess(tickets: any) {
    const authToken = await firebase!.auth()!.currentUser!.getIdToken();
    const items: Array<any> = [];

    tickets.forEach((element: any) => {
      items.push({
        uid: element.uid,
        title: element.name,
        unit_price: Number(element.price),
        quantity: element.quantity,
      });
    });

    const idEvent = await this.shopping.getUidEvent();
    const idMarketing = this.shopping.getIdMarketing();

    return this.http
      .post(
        this.url + 'checkout/access',
        { items, idEvent, tagMarketing: idMarketing },
        {
          headers: { Authorization: `Bearer ${authToken}` },
        }
      )
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error) => {
          return of(error.error);
        })
      );
  }
}
